import Vue from "vue";
import VueRouter, { RouteConfig, Route } from "vue-router";

Vue.use(VueRouter);

export const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Top",
    component: () => import(/* webpackChunkName: "about" */ "../views/Top.vue"),
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/company",
    name: "Company",
    component: () => import(/* webpackChunkName: "company" */ "../views/Company.vue"),
  },
  {
    path: "/restaurants",
    name: "Restaurants",
    component: () => import(/* webpackChunkName: "restaurants" */ "../views/Restaurants.vue"),
  },
  {
    path: "/restaurants/page/:pageNum",
    name: "RestaurantsWithPageNum",
    component: () => import(/* webpackChunkName: "restaurants" */ "../views/Restaurants.vue"),
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import(/* webpackChunkName: "privacy" */ "../views/Privacy.vue"),
  },
  {
    path: "/restaurants/:uuid",
    name: "RestaurantDetail",
    component: () => import(/* webpackChunkName: "restaurant-detail" */ "../views/RestaurantDetail.vue"),
  },
  {
    path: "/pre-register",
    name: "CPreRegister",
    component: () => import(/* webpackChunkName: "common-pre-register" */ "../views/CPreRegister.vue"),
  },
  {
    path: "/pre-register-resend",
    name: "CPreRegisterResend",
    component: () => import(/* webpackChunkName: "common-pre-register-resend" */ "../views/CPreRegisterResend.vue"),
  },
  {
    path: "/register",
    name: "CRegister",
    component: () => import(/* webpackChunkName: "common-register" */ "../views/CRegister.vue"),
  },
  {
    path: "/login",
    name: "CLogin",
    component: () => import(/* webpackChunkName: "common-login" */ "../views/CLogin.vue"),
  },
  {
    path: "/mypage/profile",
    name: "CUserProfile",
    component: () => import(/* webpackChunkName: "common-user-profile" */ "../views/CUserProfile.vue"),
  },
  {
    path: "/mypage/orders",
    name: "COrders",
    component: () => import(/* webpackChunkName: "common-orders-history" */ "../views/COrders.vue"),
  },
  {
    path: "/mypage/orders/page/:pageNum",
    name: "COrdersWithPageNum",
    component: () => import(/* webpackChunkName: "common-orders-history" */ "../views/COrders.vue"),
  },
  {
    path: "/mypage/delete",
    name: "CUserDelete",
    component: () => import(/* webpackChunkName: "common-user-delete" */ "../views/CUserDelete.vue"),
  },
  {
    path: "/reset-password",
    name: "CResetPassword",
    component: () => import(/* webpackChunkName: "common-reset-password" */ "../views/CResetPassword.vue"),
  },
  {
    path: "/set-password",
    name: "CSetPassword",
    component: () => import(/* webpackChunkName: "common-set-password" */ "../views/CSetPassword.vue"),
  },
  {
    path: "/cart",
    name: "Cart",
    component: () => import(/* webpackChunkName: "common-set-password" */ "../views/Cart.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import(/* webpackChunkName: "common-contact" */ "../views/Contact.vue"),
  },
  /** *************** */
  /*  for restaurant  */
  /** *************** */
  {
    path: "/restaurant/pre-register",
    name: "RPreRegister",
    component: () => import(/* webpackChunkName: "restaurant-pre-register" */ "../views/RPreRegister.vue"),
  },
  {
    path: "/restaurant/pre-register-resend",
    name: "RPreRegisterResend",
    component: () => import(/* webpackChunkName: "restaurant-pre-register-resend" */ "../views/RPreRegisterResend.vue"),
  },
  {
    path: "/restaurant/register",
    name: "RRegister",
    component: () => import(/* webpackChunkName: "restaurant-register" */ "../views/RRegister.vue"),
  },
  {
    path: "/restaurant/login",
    name: "RLogin",
    component: () => import(/* webpackChunkName: "restaurant-login" */ "../views/RLogin.vue"),
  },
  // {
  //   path: "/restaurant/mypage",
  //   name: "RMyPage",
  //   component: () => import(/* webpackChunkName: "restaurant-my-page" */ "../views/RMyPage.vue")
  // },
  {
    path: "/restaurant/mypage/detail",
    name: "RRestaurantDetail",
    component: () => import(/* webpackChunkName: "restaurant-restaurant-detail" */ "../views/RRestaurantDetail.vue"),
  },
  {
    path: "/restaurant/mypage/edit",
    name: "RRestaurantEdit",
    component: () => import(/* webpackChunkName: "restaurant-restaurant-edit" */ "../views/RRestaurantEdit.vue"),
  },
  {
    path: "/restaurant/mypage/orders",
    name: "ROrders",
    component: () => import(/* webpackChunkName: "restaurant-orders" */ "../views/ROrders.vue"),
  },
  {
    path: "/restaurant/mypage/orders/page/:pageNum",
    name: "ROrdersWithPageNum",
    component: () => import(/* webpackChunkName: "restaurant-orders" */ "../views/ROrders.vue"),
  },
  {
    path: "/restaurant/mypage/orders/history",
    name: "ROrdersHistory",
    component: () => import(/* webpackChunkName: "restaurant-orders-history" */ "../views/ROrdersHistory.vue"),
  },
  {
    path: "/restaurant/mypage/orders/history/page/:pageNum",
    name: "ROrdersHistoryWithPageNum",
    component: () => import(/* webpackChunkName: "restaurant-orders-history" */ "../views/ROrdersHistory.vue"),
  },
  {
    path: "/restaurant/mypage/orders/:uuid",
    name: "ROrderDetail",
    component: () => import(/* webpackChunkName: "restaurant-orders-detail" */ "../views/ROrderDetail.vue"),
  },
  {
    path: "/restaurant/mypage/orders/:uuid/edit",
    name: "REditOrder",
    component: () => import(/* webpackChunkName: "restaurant-orders-detail" */ "../views/REditOrder.vue"),
  },
  {
    path: "/restaurant/mypage/order/create",
    name: "ROrderCreate",
    component: () => import(/* webpackChunkName: "restaurant-orders-create" */ "../views/ROrderCreate.vue"),
  },
  {
    path: "/restaurant/mypage/menus",
    name: "RMenus",
    component: () => import(/* webpackChunkName: "restaurant-menus" */ "../views/RMenus.vue"),
  },
  {
    path: "/restaurant/mypage/menu/create",
    name: "RCreateMenu",
    component: () => import(/* webpackChunkName: "restaurant-create-menu" */ "../views/REditMenu.vue"),
  },
  {
    path: "/restaurant/mypage/menu/:uuid",
    name: "RMenuDetail",
    component: () => import(/* webpackChunkName: "restaurant-menu-detail" */ "../views/RMenuDetail.vue"),
  },
  {
    path: "/restaurant/mypage/menu/:uuid/edit",
    name: "REditMenu",
    component: () => import(/* webpackChunkName: "restaurant-edit-menu" */ "../views/REditMenu.vue"),
  },
  {
    path: "/restaurant/mypage/menu/:uuid/delete",
    name: "RMenuDelete",
    component: () => import(/* webpackChunkName: "restaurant-edit-menu" */ "../views/RMenuDelete.vue"),
  },
  {
    path: "/restaurant/mypage/delete",
    name: "RRestaurantDelete",
    component: () => import(/* webpackChunkName: "restaurant-user-delete" */ "../views/RRestaurantDelete.vue"),
  },
  {
    path: "/restaurant/reset-password",
    name: "RResetPassword",
    component: () => import(/* webpackChunkName: "restaurant-reset-password" */ "../views/RResetPassword.vue"),
  },
  {
    path: "/restaurant/set-password",
    name: "RSetPassword",
    component: () => import(/* webpackChunkName: "restaurant-set-password" */ "../views/RSetPassword.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line
  scrollBehavior(to: Route, from: Route, savedPosition: any) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

export default router;
